// latest: wjk 2017-12-9 10:36 AM
/* global $ u ko */

let _model
function init (refer) {
  debugger
  let view
  if (refer.params) {
    view = refer.params.view || false
  } else {
    view = false
  }
  let vm = {
    model: _model,
    view: ko.observable(view)
  }
  let app = u.createApp()
  app.init(vm, $('#new_qualify_refer')[0])
}

let template = require('./index.html')
export default function (model) {
  _model = model
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/qualifyCertRefer/index.js